import { Box, Grid, Button, InputBase, Breadcrumbs, Link, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Chip from "@mui/material/Chip";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";

import { useChartOfAccountsNextAccountsList } from "api/hooks/accounting"; 


export default function ChartNextAccounts () {
  
  const location = useLocation();
  const { id, name } = location.state;
  const navigate = useNavigate();

  const {chartNextList, isLoadingChartNextList} = useChartOfAccountsNextAccountsList(1, id)

  const[searchContent, setSearchContent] = useState("")

  const renderStatusPills = (status) => {
		switch (status) {
			case false:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffebeb", fontSize:"10px", fontWeight:700 }} label="CR" size="medium" color="warning" />;
			case true:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ebefff", fontSize:"10px", fontWeight:700 }} label="DR" size="medium" color="primary" />;
			default:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffeded", fontSize:"10px", fontWeight:700 }} label="CANCELLED" size="medium" color="danger" />;
		}
	};

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value)
  }
  
  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/accounting")}
        >
          <AccountBalanceIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Accounting
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>{name} Account Ledgers</b>
        </Typography>
      </Breadcrumbs>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <InputBase
            placeholder="Search by Name"
            value={searchContent}
            onChange={handleSearchInput}
            sx={{ ml: 1, flex: 1 }}
          />
          {/* <IconButton onClick={handleClickSearch}>
              <SearchIcon />
          </IconButton> */}
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Account Name", width: 100 },
          { label: "Account Code", width: 100 },
          { label: "Category", width: 50 },
          { label: "Ledger Balance", width: 100 },
          { label: "Status", width: 50 },
          { label: "Actions", align: "center", width: 150 },
        ]}
        rows={chartNextList}
        loading={isLoadingChartNextList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.ledger_name}</RCell>
            <RCell>{row.ledger_code}</RCell>
            <RCell>{row.related_accounting_category.accounting_category_name}</RCell>
            <RCell>{0}</RCell>
            <RCell>{renderStatusPills(row.is_active)}</RCell>
            <RCell align="center">
              <Button
                value={row.id}
                size="small"
                onClick={()=>navigate('/ledgerTransactions', {state: {id:row.id, name:row.ledger_name}})}
              >
                View Ledger Entires
              </Button>
            </RCell>
          </RRow>
        )}
      />
    </Box>
  );
};
